import { Installment } from '../StudentDetailView/types';

type UserData = {
  name: string;
  lastname: string;
  email: string;
};

type StudentData = {
  id?: string;
  userId?: string;
  rut: string;
  phoneNumber: string;
  name: string;
  lastname: string;
  email: string;
  deleted?: boolean;
  user?: UserData;
  studentId?: string;
  onlineEnabled: boolean,
  stage: string;
  year?: number;
};

type StudentProgramInfo = {
  programId: string;
  feeDiscount: number;
  comment: string;
};

type PostContractData = {
  studentId: string;
  startDate: Date;
  endDate: Date;
  tuition: number;
  tuitionDiscount: number;
  tuitionAgreement: string | null;
  tuitionPaymentType: string;
  feeDiscountType: string | null;
  feeDiscount: number;
  feeAdditionalDiscount: number | null;
  feePaymentType: string;
  feePaymentTypeDiscount: number;
  feeDiscountInvalidPaymentMethods?: string | null;
  feeDiscountValidDays?: number | null;
  studentProgramInfo: StudentProgramInfo[];
  comment?: string;
  installments: Installment[];
  status?: 'draft' | 'accepted';
  academicYear?: number;
  flow?: 'study-plan' | 'contract';
};

type PutContractData = PostContractData & {
  contractId: string;
};

const currentYear = new Date().getFullYear();

const STUDENTS_UI = [
  {
    label: 'Nombre', key: 'name', showOnTable: true, showOnModal: true, typeField: 'text', valueType: 'string',
  },
  {
    label: 'Apellidos', key: 'lastname', showOnTable: true, showOnModal: true, typeField: 'text', valueType: 'string',
  },
  {
    label: 'Rut', key: 'rut', showOnTable: true, showOnModal: true, typeField: 'text', valueType: 'string',
  },
  {
    label: 'Teléfono', key: 'phoneNumber', showOnTable: true, showOnModal: true, typeField: 'text', valueType: 'string',
  },
  {
    label: 'Email', key: 'email', showOnTable: true, showOnModal: true, typeField: 'text', valueType: 'string',
  },
  {
    label: 'Año',
    key: 'year',
    showOnTable: false,
    showOnModal: true,
    typeField: 'select',
    valueType: 'number',
    selectFields: [
      { id: currentYear, name: currentYear.toString() },
      { id: currentYear + 1, name: (currentYear + 1).toString() },
    ],
  },
  {
    label: '¿Guías online?', key: 'onlineEnabled', showOnTable: true, showOnModal: true, typeField: 'switch', valueType: 'other',
  },
  {
    label: 'Acciones', key: 'actions', showOnTable: true, showOnModal: false, typeField: 'other', valueType: 'string',
  },
  {
    label: 'Ver más', key: 'seeMore', showOnTable: true, showOnModal: false, typeField: 'other', valueType: 'string',
  },
];

export {
  StudentData,
  STUDENTS_UI,
  PostContractData,
  PutContractData,
  StudentProgramInfo,
};
